import HomePage from "./HomePage";
import VideoPage from "./VideoPage";
import AudioPage from "./AudioPage";
import TintucPage from "./TintucPage";
import HinhanhPage from "./HinhanhPage";
import KinhsachPage from "./KinhsachPage";
import ContactPage from "./ContactPage";
import BaiGIangPhoThongPage from "./BaiGIangPhoThongPage";
import TintucPageDetail from "./TintucPageDetail";
import HinhanhPageDetail from "./HinhanhPageDetail";
import { Routes, Route, Link } from 'react-router-dom';
import KinhsachPageDetail from "./KinhsachPageDetail";
import LoginPage from "./LoginPage";
import AdminPage from "./AdminPage";
import SachNoiPage from "./SachNoiPage";
import NhacPhatGiaoPage from "./NhacPhatGiaoPage";
import TrangPage from "./TrangPage";
import PageView from "./PageView";
import AudioTheoBoDetailPage from "./AudioTheoBoDetailPage";
import GiangSuDetailPage from "./GiangSuDetailPage";
import GuongSangDetailPage from "./GuongSangDetailPage";
import SachNoiDetailPage from "./SachNoiDetailPage";

function App() {
  return (
    <div>
        {/* <HomePage/> */}

        <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/video/*" element={<VideoPage />} />
        <Route path="/audio/*" element={<AudioPage />} />
        <Route path="/tin-tuc/*" element={<TintucPage />} />
        <Route path="/hinh-anh/*" element={<HinhanhPage />} />
        <Route path="/kinh-sach/*" element={<KinhsachPage />} />
        <Route path="/bai-giang-pho-thong/*" element={<BaiGIangPhoThongPage />} />
        <Route path="/tin-tuc-chi-tiet/*" element={<TintucPageDetail />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/hinh-anh-chi-tiet" element={<HinhanhPageDetail />} />
        <Route path="/kinh-sach-chi-tiet" element={<KinhsachPageDetail />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="/sach-noi/*" element={<SachNoiPage />} />
        <Route path="/nhac-phat-giao/*" element={<NhacPhatGiaoPage />} />
        <Route path="/p/:slug" element={<TrangPage />} />
        <Route path="/audio-theo-bo-chi-tiet" element={<AudioTheoBoDetailPage />} />
        <Route path="/giang-su-chi-tiet" element={<GiangSuDetailPage />} />
        <Route path="/guong-sang-chi-tiet" element={<GuongSangDetailPage />} />
        <Route path="/sach-noi-chi-tiet" element={<SachNoiDetailPage />} />
      </Routes>
    </div>
  );
}

export default App;
